import { z } from "zod";

export const Signature = z.enum(["TimothyMason", "BrianJondle"]);

export type SignatureEnum = z.infer<typeof Signature>;

export const SignatureDisplayName: Record<SignatureEnum, string> = {
  [Signature.enum.TimothyMason]: "Timothy Mason",
  [Signature.enum.BrianJondle]: "Brian Jondle",
};
